<template>
  <div class="stores">
    <v-app-bar app color="primary" dense class="header primaryText--text">
      <v-row>
        <v-col cols="3">
          <v-app-bar-nav-icon v-if="showLangSwitcher" @click="setNextLanguage" class="ml-2" style="width:auto;">
            <LanguageIcon></LanguageIcon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="6" class="d-flex justify-center align-center">
          <div>
            <v-toolbar-title class="header-title2">{{
              nextRouteName != null && nextRouteName == "Offer" ? $t("offer") : $t("order")
            }}</v-toolbar-title>
          </div>
        </v-col>

        <v-col cols="3" align-self="end" style="text-align:right">
          <v-badge
            v-show="$store.state.store != null && $store.state.order.orderItems.length > 0"
            :value="$store.state.order.qtyTotal"
            :content="$store.state.order.qtyTotal"
            color="accent"
            class="accentText--text"
            overlap
            offset-x="20"
            offset-y="20"
          >
            <v-app-bar-nav-icon @click="clickCheckout">
              <v-icon>mdi-cart-outline</v-icon>
            </v-app-bar-nav-icon>
          </v-badge>
        </v-col>
      </v-row>
    </v-app-bar>

    <EasyRefresh ref="easyRefresh" :userSelect="false" :onRefresh="reloadStores">
      <template v-slot:header>
        <ClassicsHeader height="150" />
      </template>
      <v-container>
        <div>
          <v-btn small class="mb-2" @click="reloadStores">{{ $t("refresh")}}</v-btn>
        </div>
        <GmapMap v-if="myCoords != null" :center="myCoords" :zoom="18" map-type-id="terrain" class="gmap">
          <GmapMarker :position="myCoords" :clickable="true" :draggable="true" />
        </GmapMap>

        <div class="nearby">{{ $t("nearby") }}</div>

        <v-row class="store-list">
          <v-col
            class="store"
            cols="12"
            sm="6"
            md="4"
            lg="4"
            xl="3"
            v-for="(store, index) in $store.state.stores.list"
            :key="index"
          >
            <div class="content">
              <div class="content-box">
                <div class="content-name">{{ store.info.companyName }}</div>
                <div v-if="store.info.address != null" class="content-address">
                  <div v-if="store.info.address.street != null">
                    <span
                      v-if="
                        store.info.address.unit != null &&
                          store.info.address.unit != null &&
                          store.info.address.unit != ''
                      "
                      >Unit {{ store.info.address.unit }}, </span
                    >{{ store.info.address.street }}
                  </div>
                  <div v-if="store.info.address.city != null">
                    {{ store.info.address.city }}
                    <span v-if="store.info.address.province != null">{{ store.info.address.province }}</span>
                  </div>
                  <div v-if="store.info.address.tel != null || store.distanceBetween != null">
                    <span>{{ store.info.address.tel }}</span>
                  </div>
                </div>

                <div
                  :class="
                    store.timeStatus != null && store.timeStatus.opening
                      ? 'content-business-hours'
                      : 'content-business-hours-closed'
                  "
                  v-if="store.timeStatus != null && store.timeStatus.businessTimeLocaleString != ''"
                >
                  {{ $t(store.timeStatus.businessTimeLocaleString, store.timeStatus.businessTimeParams) }}
                  <span v-if="store.timeStatus.timeZoneAbbrev != ''">({{ store.timeStatus.timeZoneAbbrev }})</span>
                </div>

                <div
                  class="content-preorder-message"
                  v-if="store.timeStatus != null && store.timeStatus.preorderLocaleString != ''"
                >
                  {{ $t(store.timeStatus.preorderLocaleString) }}
                </div>

                <div v-if="store.distanceBetween != null" class="content-distance">
                  {{ (store.distanceBetween / 1000).toFixed(2) }} km
                </div>

                <div class="mt-2">
                  <v-btn
                    v-if="!store.orderType.dinein.hide"
                    @click="clickStore(store, $store.state.OT_DINEIN)"
                    class="mr-2 mb-2"
                    :outlined="
                      !(
                        isCurrentOrderType(
                          store,
                          $store.state.OT_DINEIN
                        ) /* && $store.state.order.orderItems.length > 0*/
                      )
                    "
                    rounded
                    small
                    color="accent"
                    >{{ $t("dinein") }}</v-btn
                  >
                  <v-btn
                    v-if="!store.orderType.takeout.hide"
                    @click="clickStore(store, $store.state.OT_TAKEOUT)"
                    class="mr-2 mb-2"
                    :outlined="
                      !(
                        isCurrentOrderType(
                          store,
                          $store.state.OT_TAKEOUT
                        ) /* && $store.state.order.orderItems.length > 0*/
                      )
                    "
                    rounded
                    small
                    color="accent"
                    >{{ $t("takeout") }}</v-btn
                  >
                  <v-btn
                    v-if="!store.orderType.delivery.hide"
                    @click="clickStore(store, $store.state.OT_DELIVERY)"
                    class="mr-2 mb-2"
                    :outlined="
                      !(
                        isCurrentOrderType(
                          store,
                          $store.state.OT_DELIVERY
                        ) /* && $store.state.order.orderItems.length > 0*/
                      )
                    "
                    rounded
                    small
                    color="accent"
                    >{{ $t("delivery") }}</v-btn
                  >
                  <v-btn
                    v-if="store.service != null && store.service.waitlistEnabled"
                    :disabled="store.config.bookingWaitlistDeactivated"
                    @click="clickBooking(store, false)"
                    class="mr-2 mb-2"
                    :outlined="true"
                    rounded
                    small
                    color="accent"
                    >{{ $t("booking.waitlist") }}</v-btn
                  >
                  <v-btn
                    v-if="store.service != null && store.service.reserveEnabled"
                    :disabled="store.config.bookingReserveDeactivated"
                    @click="clickBooking(store, true)"
                    class="mr-2 mb-2"
                    :outlined="true"
                    rounded
                    small
                    color="accent"
                    >{{ $t("booking.reserve") }}</v-btn
                  >
                </div>
              </div>
            </div>

            <div class="pl-4 text-right">
              <div style="width:100%;" @click="$root.locationDialog.open(store)">
                <v-icon>mdi-information-outline</v-icon>
              </div>
              <div class="mt-2" style="width:100%;" v-show="isCurrentStore(store)">
                <!-- <v-icon color="accent">mdi-radiobox-marked</v-icon> -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </EasyRefresh>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <MemberBookingDialog ref="memberBookingDialog"></MemberBookingDialog>
  </div>
</template>

<script>
import LanguageIcon from "@/components/LanguageIcon.vue";
import MemberBookingDialog from "@/dialogs/MemberBookingDialog";

export default {
  components: {
    LanguageIcon,
    MemberBookingDialog,
  },

  beforeRouteLeave(to, from, next) {
    this.savedPosition = { x: window.scrollX, y: window.scrollY };
    next();
  },

  created() {
    console.log("Stores created");
  },

  mounted() {
    console.log("Stores mounted");
  },

  async activated() {
    console.log("Stores activated");
    //this.setTheme(this.$store.state.theme);

    //this.$store.state.memberEnabled = false;
    //this.$i18n.locale = "en";

    this.nextRouteName = null;
    if (this.$route.params.nextRouteName != null) {
      this.nextRouteName = this.$route.params.nextRouteName;
    }

    this.refreshStores();

    this.$refs.easyRefresh.scrollTo(0, false);

    //console.log("savedPosition", this.savedPosition);
    if (this.savedPosition != null) {
      this.$vuetify.goTo(this.savedPosition.y, { duration: 0 });
    }
  },

  data() {
    return {
      savedPosition: null,
      refreshing: false,
      storeClicked: false,

      nextRouteName: null,

      positionGetTime: null,
    };
  },

  computed: {
    myCoords() {
      if (this.$store.state.myCoords != null) {
        return { lat: this.$store.state.myCoords.latitude, lng: this.$store.state.myCoords.longitude };
      } else return null;
    },
  },

  methods: {
    isCurrentStore(store) {
      return this.$store.state.store != null && store.companyCode == this.$store.state.store.companyCode;
    },

    isCurrentOrderType(store, orderType) {
      return (
        this.isCurrentStore(store) &&
        //this.$store.state.order.orderItems.length > 0 &&
        this.$store.state.order.orderType == orderType
      );
    },

    async clickStore(store, orderType) {
      if (this.storeClicked) return;
      this.storeClicked = true;

      this.refreshing = true;
      try {
        let selected = await this.storeSelected(store);
        if (selected) {
          if (orderType == this.$store.state.OT_DINEIN) {
            if (store.orderType.dinein.askTableName) {
              let tableName = await this.$root.tableNameDialog();
              if (tableName != null) {
                let res = await this.rest_getTable({ tableName: tableName, sessionKey: store.sessionKey });
                if (res.result == "ok" && res.tables.length > 0) {
                  let table = res.tables[0];
                  this.$store.state.order.tableID = table.ID;
                  this.$store.state.order.tableName = table.descr;
                } else {
                  this.$root.messageDialog(
                    this.$t("error_alert_title"),
                    "",
                    this.$t("error_table_not_found", { table_name: tableName })
                  );
                  return;
                }
              } else {
                return;
              }
            }
          } else {
            this.$store.state.order.tableID = 0;
            this.$store.state.order.tableName = "";
          }
          if (this.nextRouteName == null) await this.navMenu({ orderType: orderType });
          else this.navName(this.nextRouteName);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.storeClicked = false;
        this.refreshing = false;
      }
    },

    async clickBooking(store, reserve) {
      if (this.$store.state.member == null) {
        this.navName("Login", { nextRouteName: "Stores" });
        return;
      }

      if (this.storeClicked) return;
      this.storeClicked = true;      

      this.refreshing = true;

      try {
        let selected = await this.storeSelected(store);
        if (selected) {
          this.$refs.memberBookingDialog.open(reserve);
        }
      } finally {
        this.storeClicked = false;
        this.refreshing = false;
      }
    },

    clickCheckout() {
      if (this.$store.state.store == null || this.$store.state.order.orderItems.length == 0) return;

      if (!this.$store.getters.acceptOrder) {
        this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));

        return;
      }

      this.navName("Checkout");
    },

    reloadStores(done) {
      this.refreshing = true;
      this.rest_getStores().then(res_getStores => {
        if (res_getStores.result == "ok") {
          this.$store.commit("setStores", {
            list: res_getStores.stores,
          });
          this.refreshStores(true);
        }
        this.refreshing = false;
        done();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stores {
  height: 100%;
  //height: calc(100vh - #{$header-height} - #{$bottom-toolbar-height});
}

/* .container {
  height: calc(100vh - #{$header-height});
} */
.gmap {
  width: 100%;
  height: 150px;
}

@media screen and (min-width: 600px) {
  .gmap {
    width: 100%;
    height: 100px;
  }
}

.nearby {
  font-size: 1em;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 4px 12px;
  text-transform: uppercase;
  letter-spacing: 3px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgb(220, 220, 220);
}

.store-list {
  padding-bottom: calc(48px + #{$bottom-toolbar-height}) !important;
}

.store {
  padding: 12px 24px;
  display: flex;
  //align-items: flex-start;
  //max-height: 125px;
  min-height: 110px;

  //border-bottom: dashed 1px lightgray !important;
  //border-right: dashed 1px lightgray !important;
  //border: dashed 1px rgb(220, 220, 220) !important;

  .logo {
    object-fit: contain;
    width: 100px;
    border-radius: 10px;
    float: left;
    margin-right: 10px;
  }

  .content {
    //margin-left: 10px;
    flex: 1 1 auto;

    .content-box {
      .content-name {
        font-size: 0.8em;
        font-weight: bold;
      }
      .content-address {
        font-size: 0.8em;
        line-height: 1.3;
      }

      .content-distance {
        color: #888888;
        font-size: 0.8em;
      }
    }

    .content-business-hours {
      margin-top: 4px;
      color: #888888;
      font-size: 0.8em;
    }

    .content-business-hours-closed {
      @extend .content-business-hours;
      color: var(--v-warning-base);
    }

    .content-preorder-message {
      font-size: 0.8em;
      word-wrap: normal;
    }
  }
}
</style>
